/* eslint-disable no-undef */
/* eslint-disable jquery/no-class */
/* eslint-disable jquery/no-html */
/* eslint-disable jquery/no-find */
/* eslint-disable jquery/no-text */
/* eslint-disable jquery/no-ajax */
import throttle from './throttle';

// Calculate header-banner height for scroll offset
function getPageOffset() {
  const banner = document.querySelector('.header-banner');
  const bannerHeight = banner ? Math.ceil(banner.getBoundingClientRect().height || 0) : 28;
  return bannerHeight;
}
const PAGE_OFFSET = getPageOffset();
const SCROLL_INTERVAL = 150;

/**
 * Initialise mobile search behaviour on the header
 */
const initMobileSearch = () => {
  const header = document.querySelector('.header-sticky');
  const searchIconElement = document.querySelector('.header-element__search[data-toggle="search-mobile"]');
  const isPDP = document.body.classList.contains('new-pdp');
  const storeIcon = document.querySelector('.header-element.stores.left');
  const accountIcon = document.querySelector('.header-element__user.left');

  if (!header || !searchIconElement) {
    return;
  }

  const setInitialState = () => {
    if (isPDP) {
      searchIconElement.classList.add('d-none');
    } else {
      searchIconElement.classList.add('d-block');
    }
    if (storeIcon) storeIcon.classList.add('d-none');
    if (accountIcon) accountIcon.classList.add('d-none');
  };

  setInitialState();

  // Toggle search icon and other icons based on scroll position (after header-banner)
  window.addEventListener('scroll', throttle(() => {
    if (window.pageYOffset < PAGE_OFFSET && !isPDP) {
      searchIconElement.classList.add('d-block');
      searchIconElement.classList.remove('d-none');
      if (storeIcon) storeIcon.classList.add('d-none');
      if (accountIcon) accountIcon.classList.add('d-none');
    } else {
      searchIconElement.classList.remove('d-block');
      searchIconElement.classList.add('d-none');
      if (storeIcon) storeIcon.classList.remove('d-none');
      if (accountIcon) accountIcon.classList.remove('d-none');
    }
  }, SCROLL_INTERVAL));

  // On search icon click, scroll down to show search bar
  searchIconElement.addEventListener('click', (e) => {
    e.preventDefault();

    header.classList.remove('scroll-down');
    header.classList.add('scroll-up');

    const observer = new MutationObserver((mutations) => {
      mutations.forEach(() => {
        if (header.classList.contains('scroll-down')) {
          header.classList.remove('scroll-down');
          header.classList.add('scroll-up');
        }
      });
    });
    observer.observe(header, { attributes: true, attributeFilter: ['class'] });

    window.scrollTo({
      top: (PAGE_OFFSET + 2),
      behavior: 'smooth',
    });

    const OBSERVE_MS = 200;
    setTimeout(() => {
      observer.disconnect();
      const searchInput = document.querySelector(
        '.header-item__search.lower .site-search .search-field',
      );
      if (searchInput) {
        header.classList.add('scroll-up');
        header.classList.remove('scroll-down');
        searchInput.focus();
      }
    }, OBSERVE_MS);
  });
};

/**
 * Handle search bar visibility on scroll (after header-banner)
 */
const handleSearchScroll = () => {
  const siteSearch = document.querySelector('.header-item__search.lower .site-search');

  if (!siteSearch) return;

  window.addEventListener('scroll', throttle(() => {
    if (window.pageYOffset > PAGE_OFFSET) {
      siteSearch.classList.add('search-visible');
    } else {
      siteSearch.classList.remove('search-visible');
    }
  }, SCROLL_INTERVAL));
};

// Helper to add class to menu drawer (for mobile)
const addSubnavClass = () => {
  document.querySelectorAll('.nav-menu__search .site-search').forEach((el) => {
    el.classList.add('drawer');
  });
};

const initComponents = () => {
  initMobileSearch();
  handleSearchScroll();
  addSubnavClass();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initComponents);
} else {
  initComponents();
}
